import { Component, Input, Output, EventEmitter, TemplateRef, OnInit } from '@angular/core';

import { toString } from '../util/util';

/**
 * Context for the typeahead result template in case you want to override the default one
 */
export interface ResultTemplateContext {
  /**
   * Your typeahead result data model
   */
  result: any;

  /**
   * Search term from the input used to get current result
   */
  term: string;
}


export class FishTypeaheadWindow implements OnInit {
  activeIdx = 0;

  /**
   *  The id for the typeahead widnow. The id should be unique and the same
   *  as the associated typeahead's id.
   */
   id: string;

  /**
   * Flag indicating if the first row should be active initially
   */
   focusFirst = true;

  /**
   * Typeahead match results to be displayed
   */
   results;

  /**
   * Search term used to get current results
   */
   term: string;

  /**
   * A function used to format a given result before display. This function should return a formatted string without any
   * HTML markup
   */
   formatter = toString;

  /**
   * A template to override a matching result default display
   */
   resultTemplate: TemplateRef<ResultTemplateContext>;

  /**
   * Event raised when user selects a particular result row
   */
   selectEvent = new EventEmitter();

   activeChangeEvent = new EventEmitter();

  _getResultContext(result: any) { return { result: result, term: this.term, formatter: this.formatter }; }

  getActive() { return this.results[this.activeIdx]; }

  markActive(activeIdx: number) {
    this.activeIdx = activeIdx;
    this._activeChanged();
  }

  next() {
    if (this.activeIdx === this.results.length - 1) {
      this.activeIdx = this.focusFirst ? (this.activeIdx + 1) % this.results.length : -1;
    } else {
      this.activeIdx++;
    }
    this._activeChanged();
  }

  prev() {
    if (this.activeIdx < 0) {
      this.activeIdx = this.results.length - 1;
    } else if (this.activeIdx === 0) {
      this.activeIdx = this.focusFirst ? this.results.length - 1 : -1;
    } else {
      this.activeIdx--;
    }
    this._activeChanged();
  }

  select(item) { this.selectEvent.emit(item); }

  ngOnInit() {
    this.activeIdx = this.focusFirst ? 0 : -1;
    this._activeChanged();
  }

  private _activeChanged() {
    this.activeChangeEvent.emit(this.activeIdx >= 0 ? this.id + '-' + this.activeIdx : undefined);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'fish-typeahead-window',
  exportAs: 'fishTypeaheadWindow',
  host: { 'class': 'dropdown-menu', 'style': 'display: block', 'role': 'listbox', '[id]': 'id' },
  template: `
    <ng-template #rt let-result="result" let-term="term" let-formatter="formatter">
      <fish-highlight [result]="formatter(result)" [term]="term"></fish-highlight>
    </ng-template>
    <ng-template ngFor [ngForOf]="results" let-result let-idx="index">
      <button type="button" class="dropdown-item" role="option"
        [id]="id + '-' + idx"
        [class.active]="idx === activeIdx"
        (mouseenter)="markActive(idx)"
        (click)="select(result)">
          <ng-template [ngTemplateOutlet]="resultTemplate || rt"
          [ngOutletContext]="_getResultContext(result)"></ng-template>
      </button>
    </ng-template>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'id': [{ type: Input },],
'focusFirst': [{ type: Input },],
'results': [{ type: Input },],
'term': [{ type: Input },],
'formatter': [{ type: Input },],
'resultTemplate': [{ type: Input },],
'selectEvent': [{ type: Output, args: ['select', ] },],
'activeChangeEvent': [{ type: Output, args: ['activeChange', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
